var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.momentFromNow(_vm.lastStatus).class},[_vm._v("\n  "+_vm._s(_vm.momentFromNow(_vm.lastStatus).fromnow)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }